import { useState } from "react";
import type { FeatureCatalogEntry } from "../../features/subscriptions/types";

interface FeatureInfoTooltipProps {
  entry?: FeatureCatalogEntry;
}

/** Small (i) help icon that shows a feature's title and description on
 * hover/click. Renders nothing if no catalog entry is found. */
export default function FeatureInfoTooltip({ entry }: FeatureInfoTooltipProps) {
  const [open, setOpen] = useState(false);
  if (!entry) return null;

  return (
    <span
      className="relative inline-flex items-center"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-label={`About ${entry.label}`}
        className="ml-1 inline-flex items-center justify-center w-3.5 h-3.5 rounded-full border border-gray-600 text-[9px] leading-none text-gray-500 hover:text-white hover:border-gray-400 transition-colors"
      >
        i
      </button>
      {open && (
        <div className="absolute z-20 left-1/2 -translate-x-1/2 bottom-full mb-2 w-64 rounded-lg border border-gray-700 bg-gray-950 p-3 text-left shadow-xl">
          <p className="text-xs font-semibold text-white mb-1">{entry.label}</p>
          <p className="text-xs text-gray-400">{entry.description}</p>
        </div>
      )}
    </span>
  );
}
